import { useNavigate } from "react-router-dom";

import { ROUTE_PATHS } from "../routes/paths";
import { useAuth } from "../../context/AuthContext";

const NotFoundPage = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  const target = user?.role === "admin" ? ROUTE_PATHS.adminRoot : ROUTE_PATHS.home;

  return (
    <div className="min-h-screen app-page-bg flex items-center justify-center px-4">
      <div className="w-full max-w-md rounded-2xl border border-border-soft bg-bg-card p-6 text-center shadow-soft">
        <h1 className="text-2xl font-semibold text-text-primary">Page not found</h1>
        <p className="mt-2 text-sm text-text-body">
          The page you requested does not exist.
        </p>
        <button
          type="button"
          onClick={() => navigate(target, { replace: true })}
          className="mt-5 h-11 w-full rounded-xl bg-brand text-text-inverted font-semibold hover:bg-brand-hover transition"
        >
          Go back
        </button>
      </div>
    </div>
  );
};

export default NotFoundPage;






